export default function create(options) {
  const easing = 'sineOut';
  const {
    angle = 22,
    direction = 'counter-clockwise'
  } = options.namedEffect;
  return [{
    ...options,
    easing,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffsetAdd: '100vh',
    keyframes: [{
      transform: `rotate(${direction === 'counter-clockwise' ? angle : -angle}deg)`
    }, {
      transform: 'rotate(0deg)'
    }]
  }];
}
//# sourceMappingURL=BgRotate.js.map